import React, { useRef, useState } from 'react';
import DOMPurify from 'dompurify';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles'

interface ExpandableParagraphProps {
  content: string;
  lineClamp?: number;
  fontFamily?: string;
  fontWeight?: string | number;
  callback?: () => void;
  className?: string;
}

const extractNumber = (value: string | number | undefined): number => {
  const match = String(value).match(/(\d+(\.\d+)?)/);
  return match ? parseFloat(match[0]) : 0;
};

const ExpandableParagraph: React.FC<ExpandableParagraphProps> = ({ content, lineClamp = 3, fontFamily, fontWeight, callback }) => {
  const theme = useTheme();
  const lineHeight = extractNumber(theme.typography.p?.lineHeight);
  const [height, setHeight] = useState<string>((Math.floor(lineHeight) * lineClamp + 1) + 'rem');
  const textContainerRef = useRef<HTMLDivElement>(null)

  const toggleParagraph = () => {
    const maxHeight = textContainerRef.current!.scrollHeight;

    if (maxHeight / 10 <= Math.ceil(lineHeight * lineClamp) && callback) {
      callback();
    } else if (maxHeight / 10 > Math.ceil(lineHeight * lineClamp)) {
      if (height === (Math.floor(lineHeight) * lineClamp + 1) + 'rem') {
        setHeight(`${maxHeight}px`);
      } else if (callback) {
        callback()
      } else {
        setHeight((Math.floor(lineHeight) * lineClamp + 1) + 'rem');

      }
    }
  }

  return (
    <>
      <div style={{maxHeight: height, overflow: 'hidden', transition: 'height 0.5s' }}
      >
          <Typography variant='body1' component='div' ref={textContainerRef} onClick={toggleParagraph} fontFamily={fontFamily} fontWeight={fontWeight}
            sx={{
              WebkitLineClamp: height === (Math.floor(lineHeight) * lineClamp + 1) + 'rem' ? lineClamp : 'unset',
              m: '0', 
              textOverflow: 'ellipsis', 
              overflow: 'hidden',
              height: '100%', width: '100%',
              WebkitBoxOrient: 'vertical', display: '-webkit-box',
              transition: 'max-height 0.5s ease-in-out'
            }}
          >
            {typeof content === 'string' && DOMPurify.sanitize(content, { ALLOWED_TAGS: [] })}
          </Typography>
      </div>
    </>
  );
};

export default ExpandableParagraph;
